import http from "../http/http-config";
import { VWHealthGridGroup } from "../models/vwHealthGridGroup";

export default new class getVWHealthGridGroups {
    getVWHealthGridGroups(productId, onDate, correlationInformation, userName, userToken, tokenType): Promise<VWHealthGridGroup[]> {
        return http.get<VWHealthGridGroup[]>("GetVWHealthGridGroups", {
            params: {
                productId,
                onDate,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}
